// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { Heading } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import { CalendarEventForm } from "@s-i-s-i/see-learning.shared";
import { Main } from "../../../../Components";
import { calendarEventHubDetailPageInfo } from "../DetailPage/pageinfo";
import { calendarEventHubCreatePageInfo } from "./pageinfo";

export function CalendarEventHubCreatePage() {
	useActivePageRegistration(calendarEventHubCreatePageInfo);

	const { push: pushHistory } = useHistory();
	const onSuccess = React.useCallback<CalendarEventForm.ControlledCreateProps["onSuccess"]>(
		(_formState, { id }) => {
			pushHistory(calendarEventHubDetailPageInfo.to(id));
		},
		[pushHistory],
	);

	return (
		<Main>
			<Heading.H1>New Calendar Event</Heading.H1>

			<CalendarEventForm.ControlledCreate onSuccess={onSuccess} />
		</Main>
	);
}
